import ListItemIcon from '@core/components/Menu/ListItemIcon';
import { PageHeader } from '@core/components/PageHeader';
import { useDebounce } from '@fuse/hooks';
import { Button, Grid, InputAdornment, TextField, Tooltip } from '@material-ui/core';
import { Search } from '@material-ui/icons';
import DatePicker from 'app/main/faturamento/kanban/components/DatePickers';
import moment from 'moment';
import React, { useContext, useRef } from 'react';
import { FaFileAlt } from 'react-icons/fa';
import { NotaFiscalContext } from '../NotaFiscalContext';
import { NotaFiscalModais } from './Modal/NotaFiscalModais';
import { notaFiscalStyles } from './styles';

const NotaFiscalSearchHeader = ({ onChange }) => {
  const styles = notaFiscalStyles();
  const [data, setData] = useContext(NotaFiscalContext).data;
  const [search] = useContext(NotaFiscalContext).search;
  const [, setModal] = useContext(NotaFiscalContext).modal;

  const ref = useRef();

  const pesquisarPorCliente = useDebounce(
    (data, value) => {
      onChange({ q: value, mesCompetencia: data });
    },
    500,
    {}
  );

  const pesquisarPorData = (e) => {
    const dataFormatada = moment(e).format('YYYY-MM-DD');
    setData(dataFormatada);
    onChange({ q: search?.q, mesCompetencia: dataFormatada });
  };

  const handleOpenBuscaAvancada = () => {
    setModal(NotaFiscalModais.buscaAvancada);
  };

  return (
    <PageHeader
      title="Notas Fiscais"
      icon={<FaFileAlt size={32} className={styles.icon} />}
      button={
        <ListItemIcon
          key="list"
          icon={<label style={{ fontSize: '22px', cursor: 'pointer' }}>NF</label>}
          title="Nota Fiscal"
          customStyles={styles.buttonIconNf}
          listItem={[
            {
              title: 'Lançar nota de remessa',
              onClick: () => setModal('notaRemessa'),
              hint: 'Lançar nota de remessa',
              hide: false,
            },
            {
              title: 'Lançar nota de devolução',
              onClick: () => setModal('notaDevolucao'),
              hint: 'Lançar nota de devolução',
              hide: false,
            },
          ]}
        />
      }
    >
      <div className="stepDataPesquisa">
        <Grid container className={styles.header}>
          <Grid item lg={2} md={2} sm={2} xs={12}>
            <Tooltip
              title="Mês de emissão das Notas Fiscais"
              children={<DatePicker ref={ref} onChangeDate={pesquisarPorData} />}
            />
          </Grid>
          <Grid item lg={1} md={1} sm={1} xs={1} />
          <Grid item lg={8} md={8} sm={8} xs={8}>
            <TextField
              fullWidth
              placeholder="Pesquise pelo cliente"
              onChange={(e) => {
                pesquisarPorCliente(data, e.target.value);
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Search />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item lg={1} md={1} sm={1} xs={1} />
          <Grid item lg={12} md={12} sm={12} xs={12} className={styles.buscaAvancadaButton}>
            <div className="stepBuscaAvancada">
              <Button className={styles.link} onClick={handleOpenBuscaAvancada}>
                Busca avançada
              </Button>
            </div>
          </Grid>
        </Grid>
      </div>
    </PageHeader>
  );
};

export default NotaFiscalSearchHeader;
